var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.dialog
        ? _c("PostingModal", {
            attrs: {
              showDialog: _vm.dialog,
              companyId: _vm.companyId,
              managerId: _vm.managerId,
            },
            on: {
              toggle: function ($event) {
                _vm.dialog = false
              },
            },
          })
        : _vm._e(),
      _c(
        "UiButton",
        {
          staticClass: "mt-24 mr-12",
          attrs: {
            disabled: _vm.noCompany,
            size: _vm.size,
            variant: "blue",
            id: "postingModalButton",
          },
          on: { click: _vm.toggle },
          scopedSlots: _vm._u([
            {
              key: "icon",
              fn: function () {
                return undefined
              },
              proxy: true,
            },
          ]),
        },
        [_c("div", [_vm._v(_vm._s(_vm.text))])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }